import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ThemesService {

    styleTag: any;
    defaultTheme: string = 'A';
    private themeCache: { [key: string]: string } = {};

    constructor(private http: HttpClient) {
        this.createStyle();
        this.setTheme(this.defaultTheme);
    }

    private createStyle() {
        const head = document.head || document.getElementsByTagName('head')[0];
        this.styleTag = document.createElement('style');
        this.styleTag.type = 'text/css';
        this.styleTag.id = 'appthemes';
        head.appendChild(this.styleTag);
    }

    setTheme(name) {
        const themeName = name.toLowerCase();
        
        // Check if theme is already cached
        if (this.themeCache[themeName]) {
            this.injectStylesheet(this.themeCache[themeName]);
            return;
        }

        // Load theme CSS file
        this.http.get(`assets/themes/theme-${themeName}.css`, { responseType: 'text' })
            .subscribe({
                next: (css) => {
                    this.themeCache[themeName] = css;
                    this.injectStylesheet(css);
                },
                error: (error) => {
                    console.error(`Failed to load theme ${themeName}:`, error);
                }
            });
    }

    injectStylesheet(css) {
        this.styleTag.innerHTML = css;
    }

    getDefaultTheme() {
        return this.defaultTheme;
    }

}
